import Footer from '../../sections/footer/Footer'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'

import './style.scss'
import HeaderPages from '../../sections/header/HeaderPages'

function Privacy() {
	
	return (
		<>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<HeaderPages />
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<p>Lengal terms</p>
					<h1>Skivio Privacy Policy</h1>
					<p>
						<b>Effective Date: July 10th 2025</b>
					</p>
					<p>At Skivio, your privacy matters. This Privacy Policy explains how we collect, use, share, and protect your personal information when you use our website, mobile app, and related services (collectively, the “Platform”).</p>
					<p>By using Skivio, you agree to the terms of this policy. If you do not agree, please do not use the Platform.</p>
					<ol>
						<li>
							<h2>Information We Collect</h2>
							<p>We collect the following types of information:</p>
							<ol type='a' className='ordered-list-alpha'>
								<li>
									<h3>Information You Provide</h3>
									<ul>
										<li>When you create an account, book a session, or apply to become an instructor, we collect personal details such as:</li>
										<ul>
											<li>Name</li>
											<li>Email address</li>
											<li>Phone number</li>
											<li>Billing information</li>
											<li>Profile picture (optional)</li>
											<li>Certification details (instructors only)</li>
										</ul>
									</ul>
								</li>
								<li>
									<h3>Automatically Collected Information</h3>
									<ul>
										<li>Device type and browser</li>
										<li>IP address</li>
										<li>Usage data (e.g., pages viewed, actions taken)</li>
										<li>Location data (if enabled)</li>
									</ul>
								</li>
								<li>
									<h3>Payment Information</h3>
									<ul>
										<li>All payment transactions are handled by third-party processors. We do not store full credit card details on our servers.</li>
									</ul>
								</li>
							</ol>
						</li>
						<li>
							<h2>How We Use Your Information</h2>
							<p>We use your information to:</p>
							<ul>
								<li>Facilitate bookings between instructors and consumers</li>
								<li>Verify instructor qualifications and identities</li>
								<li>Process payments and issue payouts</li>
								<li>Improve the functionality and security of the Platform</li>
								<li>Send transactional and promotional communications</li>
								<li>Respond to support inquiries</li>
							</ul>
						</li>
						<li>
							<h2>Sharing Your Information</h2>
							<p>We do <b>not</b> sell your personal data. We only share information in these limited circumstances:</p>
							<ul>
								<li>With instructors and consumers for the purpose of fulfilling a booking</li>
								<li>With service providers (e.g., payment processors, cloud hosting)</li>
								<li>When legally required (e.g., to comply with a court order or government request)</li>
								<li>To protect Skivio's rights or safety</li>
							</ul>
						</li>
						<li>
							<h2>Cookies and Tracking Technologies</h2>
							<p>Skivio uses cookies and similar technologies to enhance user experience, track usage patterns, and deliver relevant content. You can control cookie settings through your browser preferences.</p>
						</li>
						<li>
							<h2>Data Security</h2>
							<p>We implement industry-standard measures to protect your data, including encryption, secure servers, and limited access protocols. However, no online system is 100% secure, and we cannot guarantee absolute protection.</p>
						</li>
						<li>
							<h2>Your Rights & Choices</h2>
							<p>Depending on your location, you may have the right to:</p>
							<ul>
								<li>Access the data we hold about you</li>
								<li>Request correction or deletion</li>
								<li>Withdraw consent to marketing emails</li>
								<li>Request data portability</li>
							</ul>
							<p>To make a request, contact us at <a href='mailto:privacy@skivio.co'>privacy@skivio.co</a>.</p>
						</li>
						<li>
							<h2>Data Retention</h2>
							<p>We retain your information as long as necessary to provide services, comply with legal obligations, and resolve disputes. You may request deletion of your account at any time.</p>
						</li>
						<li>
							<h2>Children's Privacy</h2>
							<p>Skivio is not intended for individuals under the age of 13. We do not knowingly collect personal data from children without parental consent.</p>
						</li>
						<li>
							<h2>Third-Party Links</h2>
							<p>Our Platform may contain links to third-party sites. We are not responsible for the privacy practices or content of those websites.</p>
						</li>
						<li>
							<h2>Changes to This Policy</h2>
							<p>We may update this Privacy Policy from time to time. Any changes will be posted here, with an updated “Effective Date.” Continued use of Skivio after changes indicates your acceptance.</p>
						</li>
						<li>
							<h2>Contact Us</h2>
							<p>
								For questions or concerns about these Terms, please contact:
								<br/><b>Skivio Support TeamEmail:</b>
								<br/><a href='mailto:support@skivio.co'>support@skivio.co</a>
							</p>
						</li>
					</ol>
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
			<BackToTopButton />
		</>
	)
}

export default Privacy
